module.exports = __webpack_public_path__ + "static/media/vmware-options.396b81e3.jpg";